import { render, staticRenderFns } from "./GaiYao.vue?vue&type=template&id=47f9954b&scoped=true"
import script from "./GaiYao.vue?vue&type=script&lang=js"
export * from "./GaiYao.vue?vue&type=script&lang=js"
import style0 from "./GaiYao.vue?vue&type=style&index=0&id=47f9954b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9954b",
  null
  
)

export default component.exports